import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectChat } from 'store/chatSlice';
import { incrementUnreadCountForConversation, selectInboxConversation } from 'store/inboxSlice';
import { selectUserProfileDataData } from 'store/userSlice';
import useSharedWebSocket from './useSharedWebSocket';
const useInboxMessageSubscription = () => {
    const dispatch = useDispatch();
    const { subscribe, unsubscribe, sendMessage: sendWebSocketMessage, isConnected, } = useSharedWebSocket();
    const currentUser = useSelector(selectUserProfileDataData);
    const currentConversation = useSelector(selectInboxConversation);
    const chatConversation = useSelector(selectChat);
    const isSubscribedRef = useRef(false);
    const subscriptionSentRef = useRef(false);
    const subscriberId = useRef('inbox-message-subscription');
    useEffect(() => {
        if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) {
            return undefined;
        }
        if (isSubscribedRef.current) {
            return undefined;
        }
        isSubscribedRef.current = true;
        const handleMessage = (data) => {
            if (data.type === 'connection_ack') {
                if (!subscriptionSentRef.current) {
                    setTimeout(() => {
                        sendWebSocketMessage({
                            type: 'subscribe_inbox_messages',
                            id: `inbox_msg_sub_${Date.now()}`,
                            payload: {
                                userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                            },
                        });
                        subscriptionSentRef.current = true;
                    }, 100);
                }
                return;
            }
            if (data.type === 'inbox_message_subscription_ack') {
                return;
            }
            if (data.type === 'new_inbox_message' && data.payload) {
                const { message, conversationId } = data.payload;
                if (currentUser && message.sender && currentUser.id !== message.sender.id) {
                    const isInboxConversationOpen = currentConversation && currentConversation.id === conversationId;
                    const isChatConversationOpen = chatConversation && chatConversation.id === conversationId;
                    const isConversationOpen = isInboxConversationOpen || isChatConversationOpen;
                    if (!isConversationOpen) {
                        dispatch(incrementUnreadCountForConversation({ conversationId }));
                    }
                }
            }
        };
        const handleConnectionChange = (connected) => {
            if (connected) {
                // Always re-subscribe when connection is established (including reconnections)
                subscriptionSentRef.current = false;
                setTimeout(() => {
                    if (!subscriptionSentRef.current) {
                        sendWebSocketMessage({
                            type: 'subscribe_inbox_messages',
                            id: `inbox_msg_sub_${Date.now()}`,
                            payload: {
                                userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                            },
                        });
                        subscriptionSentRef.current = true;
                    }
                }, 100);
            }
        };
        const currentSubscriberId = subscriberId.current;
        subscribe({
            id: currentSubscriberId,
            onMessage: handleMessage,
            onConnectionChange: handleConnectionChange,
        });
        return () => {
            isSubscribedRef.current = false;
            unsubscribe(currentSubscriberId);
        };
    }, [
        dispatch,
        subscribe,
        unsubscribe,
        sendWebSocketMessage,
        currentUser,
        currentConversation,
        chatConversation,
    ]);
    return {
        isConnected,
        hasWebSocket: Boolean(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id),
    };
};
export default useInboxMessageSubscription;
